export default "__VITE_ASSET__CuuI4o5$__"